<template>
  <div class="edit">
    <div class="edit-content">
      <div>
        <div>
          <div class="edit-item edit-form">
            <div class="title">
              信息共享
            </div>
            <el-switch v-model="editForm.share" :active-value="1" :inactive-value="0">
            </el-switch>
          </div>
        </div>
        <div v-for="(ele, index) in editForm.formProps" :key="index" class="edit-form">
          <template v-if="ele.label == '申请人特殊要求'">
            <div class="edit-item ">
              <div class="title">
                申请人特殊要求
              </div>
              <el-switch v-model="ele.show" :active-value="1" :inactive-value="0">
              </el-switch>
              <el-checkbox :true-label="1" :false-label="0" style="margin-left: 20px"
                v-model="ele.required">必填</el-checkbox>
            </div>
            <div class="edit-item edit-form">
              <div class="title">
                申请人特殊要求提示文字
              </div>
              <el-input placeholder="请输入内容" v-model="ele.describe" @input="ele.placeholder = ele.describe"></el-input>
            </div>
          </template>
        </div>
      </div>
      <div>
        <div v-for="(ele, index) in editForm.formProps" :key="index" class="edit-form">
          <template v-if="ele.label == '开票类型'">
            {{ ele.label }}
            <div class="edit-item" v-if="ele.propOptions">
              <div class="title">选项</div>
              <div id="formInvoiceBankAccount">
                <div class="select edit-item2" v-for="(propItem, propIndex) in ele.propOptions" :key="propIndex">
                  <img src="@/assets/tuozhuai.png" class="tuozhuai" />
                  <el-input v-model="propItem.value" placeholder="请输入内容"></el-input>
                  <span @click="removeSelect(ele.propOptions, propIndex, ele.label)">
                    <i class="el-icon-delete"></i>
                  </span>
                </div>
              </div>
              <div class="addedit">
                <span @click="batchClick1(ele.propOptions, ele.label)">批量编辑</span>
                <span @click="addSelect(ele.propOptions)">添加选项</span>
              </div>
            </div>
            <div class="edit-item" v-if="ele.propOptions">
              <div class="title">默认值</div>
              <div>
                <el-select v-model="ele.defaultValue">
                  <el-option v-for="e in ele.propOptions" :key="e.key" :label="e.value" :value="e.key"></el-option>
                </el-select>
              </div>
            </div>
          </template>
          <div v-if="ele.label == '明细'">
            <div v-for="(item, index1) in ele.formProps" :key="index1" class="edit-form">
              <template v-if="item.label == '开票内容'">
                {{ item.label }}
                <div class="edit-item" v-if="item.propOptions">
                  <div class="title">选项</div>
                  <div id="billingContent">
                    <div class="select edit-item2" v-for="(propItem, propIndex) in item.propOptions" :key="propIndex">
                      <img src="@/assets/tuozhuai.png" class="tuozhuai" />
                      <el-input v-model="propItem.value" placeholder="请输入内容"></el-input>
                      <span @click="removeSelect(item.propOptions, propIndex, item.label)">
                        <i class="el-icon-delete"></i>
                      </span>
                    </div>
                  </div>
                  <div class="addedit">
                    <span @click="batchClick1(item.propOptions, item.label)">批量编辑</span>
                    <span @click="addSelect(item.propOptions)">添加选项</span>
                  </div>
                </div>
                <div class="edit-item" v-if="item.propOptions">
                  <div class="title">默认值</div>
                  <div>
                    <el-select v-model="item.defaultValue">
                      <el-option v-for="e in item.propOptions" :key="e.key" :label="e.value" :value="e.key"></el-option>
                    </el-select>
                  </div>
                </div>
              </template>
              <template v-if="item.label == '开票税率'">
                {{ item.label }}
                <div class="edit-item" v-if="item.propOptions">
                  <div class="title">选项</div>
                  <div id="taxRate">
                    <div class="select edit-item2" v-for="(propItem, propIndex) in item.propOptions" :key="propIndex">
                      <img src="@/assets/tuozhuai.png" class="tuozhuai" />
                      <el-input v-model="propItem.value" placeholder="请输入内容"></el-input>
                      <span @click="removeSelect(item.propOptions, propIndex, item.label)">
                        <i class="el-icon-delete"></i>
                      </span>
                    </div>
                  </div>
                  <div class="addedit">
                    <span @click="batchClick1(item.propOptions, item.label)">批量编辑</span>
                    <span @click="addSelect(item.propOptions)">添加选项</span>
                  </div>
                </div>
                <div class="edit-item" v-if="item.propOptions">
                  <div class="title">默认值</div>
                  <div>
                    <el-select v-model="item.defaultValue">
                      <el-option v-for="e in item.propOptions" :key="e.key" :label="e.value" :value="e.key"></el-option>
                    </el-select>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>

      <div class="edit-item">
        <div class="title">
          打印表单
          <span>打印以下字段</span>
        </div>
        <el-switch v-model="editForm.pint" :active-value="1" :inactive-value="0" @change="updatePint">
        </el-switch>
      </div>
      <div v-for="(ele, index) in editForm.formProps" :key="index">
        <template>
          <div class="edit-item1" v-if="ele.label !== '明细' && ele.label !== '添加'">
            <div class="title">
              {{ ele.label }}
              <el-checkbox :true-label="1" :false-label="0" style="margin-left: 20px" v-model="ele.pint"
                :disabled="editForm.pint == 0 ? true : false"></el-checkbox>
            </div>
          </div>
          <div v-for="(item, index1) in ele.formProps" :key="index1">
            <div class="edit-item1">
              <div class="title">
                {{ item.label }}
                <el-checkbox :true-label="1" :false-label="0" style="margin-left: 20px" v-model="item.pint"></el-checkbox>
              </div>

            </div>
          </div>
        </template>
      </div>
    </div>
    <Modal2 top="100px" title="批量编辑" :close-on-click-modal="false" :visible.sync="isShow" width="500px">
      <div class="dialog_box">
        <div class="dialog_edit">
          <div style="margin-bottom: 12px" class="edit_input">
            <el-input type="textarea" v-model="form.str"></el-input>
          </div>
        </div>
        <div slot="footer" class="dialog_btn">
          <el-button @click="isShow = false">取 消</el-button>
          <el-button type="primary" @click="submitEdit">确 定</el-button>
        </div>
      </div>
    </Modal2>
  </div>
</template>

<script>
import Sortable from "sortablejs";
export default {
  props: {
    editForm: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      form: {
        list: [],
        type: ""
      },
      isShow: false
    }
  },
  mounted() {
    let that = this;
    this.editForm.formProps.forEach(element => {
      if (element.label == '开票类型') {
        let el = document.getElementById('formInvoiceBankAccount');
        // 常用
        new Sortable(el, {
          animation: 150,
          group: {
            name: "shared",
            pull: "clone",
            put: false, // 不允许拖拽进这个列表
          },
          onEnd: function (evt) {
            // 获取排序之后的data数据
            element.propOptions.splice(
              evt.newIndex,
              0,
              element.propOptions.splice(evt.oldIndex, 1)[0]
            );
            var newArray = element.propOptions.slice(0);
            element.propOptions = [];
            that.$nextTick(function () {
              element.propOptions = newArray;
            });
          },
        });
      }
      if (element.formProps) {
        element.formProps.forEach(ele => {
          if (ele.label == '开票内容') {
            let el = document.getElementById('billingContent');
            // 常用
            new Sortable(el, {
              animation: 150,
              group: {
                name: "shared",
                pull: "clone",
                put: false, // 不允许拖拽进这个列表
              },
              onEnd: function (evt) {
                // 获取排序之后的data数据
                ele.propOptions.splice(
                  evt.newIndex,
                  0,
                  ele.propOptions.splice(evt.oldIndex, 1)[0]
                );
                var newArray = ele.propOptions.slice(0);
                ele.propOptions = [];
                that.$nextTick(function () {
                  ele.propOptions = newArray;
                });
              },
            });
          } else if (ele.label == '开票税率') {
            let el = document.getElementById('taxRate');
            // 常用
            new Sortable(el, {
              animation: 150,
              group: {
                name: "shared",
                pull: "clone",
                put: false, // 不允许拖拽进这个列表
              },
              onEnd: function (evt) {
                // 获取排序之后的data数据
                ele.propOptions.splice(
                  evt.newIndex,
                  0,
                  ele.propOptions.splice(evt.oldIndex, 1)[0]
                );
                var newArray = ele.propOptions.slice(0);
                ele.propOptions = [];
                that.$nextTick(function () {
                  ele.propOptions = newArray;
                });
              },
            });
          }
        });
      }
    });
    // setTimeout(() => {

    // }, 500);
  },
  methods: {
    batchClick1(list, type) {
      let array = [];
      list.forEach(element => {
        array.push(element.value);
      });
      this.form = {
        list: [],
        type: type,
        str: ''
      };
      this.isShow = true;
      // this.form.list = JSON.parse(JSON.stringify(list))
      for (let i = 0; i < array.length; i++) {//其实就是按行拆，加上\n而已，相当于“a\n b\n c\n”
        array[i] = array[i].replace("\r", "");
        array[i] = array[i].split("\n");
        this.form.list.push(array[i] + "\n")
      }
      this.form.str = this.form.list.join("");
    },
    // 确定编辑
    submitEdit() {
      let array = [];
      let arrayList = [];
      array = this.form.str.split(/[(\r\n)\r\n]+/);
      array.forEach((element, index) => {
        if (element !== '') {
          arrayList.push({ key: index, value: element })
        }
      });
      this.editForm.formProps.forEach(item => {
        if (item.label == this.form.type) {
          item.propOptions = JSON.parse(JSON.stringify(arrayList));
        } else {
          if (item.formProps) {
            item.formProps.forEach(element => {
              if (element.label == this.form.type) {
                element.propOptions = JSON.parse(JSON.stringify(arrayList));
              }
            });
          }
        }
      });

      this.isShow = false;
    },
    addSelect(list) {
      list.push({
        key: `${list.length}`,
        value: `默认数据${list.length + 1}`,
      });
    },
    removeSelect(list, index, label) {

      list.splice(index, 1)

    },
    updatePint(event) {
      this.editForm.formProps.forEach(element => {
        element.pint = event;
        if (element.formProps) {
          element.formProps.forEach(item => {
            item.pint = event;
          });
        }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.tuozhuai {
  width: 20px;
  height: 20px;
}

.edit-form {
  margin-bottom: 30px !important;
}

.edit-item2 {
  font-size: 12px;
}

.draggable-none {
  // margin: 42px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 42px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  color: #999999;

  img {
    margin-right: 12px;
  }
}

.edit-none {
  height: 100%;
  color: #999999;
  position: relative;

  span {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}

.edit-number {
  width: 100%;
  line-height: 40px;
  background-color: #ffeeee;
  color: #d43030;
  font-size: 12px;
  text-align: center;
  margin-bottom: 16px;
}

.edit-title {
  color: #0f66f2;
  margin-bottom: 24px;

  .iconfont {
    margin-right: 8px;
  }
}

.edit-column {
  text-align: center;
  margin: 35% 0 0;
  color: #999999;

  div {
    line-height: 36px;
  }
}

.addedit {
  padding: 12px 0;
  color: #0f66f2;

  span {
    padding: 0 8px;
    cursor: pointer;

    &:nth-of-type(1) {
      border-right: 1px solid #eeeeee;
    }
  }
}

.edit-item {
  // margin-bottom: 12px;

  .title {
    margin-bottom: 12px;

    span {
      font-size: 12px;
      color: #999;
    }

    i {
      font-style: normal;
      color: #0f66f2;
    }
  }
}

.edit-item1 {
  .title {
    display: flex;
    margin-bottom: 10px;

    .el-checkbox {
      flex: 1;
      display: flex;
      justify-content: flex-end;
    }
  }
}

.edit-item2 {
  margin-bottom: 12px;
}

.edit-have {
  height: 100%;
}

.edit-item-list {
  margin-bottom: 8px;
}

.edit-ul {
  width: 80%;
  margin: 16px auto;

  li {
    display: flex;
    padding: 6px;
    border: 1px solid #eeeeee;

    div {
      width: 50%;
      text-align: center;

      &:nth-of-type(1) {
        border-right: 1px solid #eeeeee;
      }
    }
  }
}

.dialog_edit {
  ::v-deep .el-textarea__inner {
    height: 200px;
  }
}
</style>
